import {
  base_colorAction,
  base_colorContentBorder,
  base_colorContentBorderSecondary,
  base_colorSurface,
  base_contentBackground,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: inline-flex;
  align-self: flex-start;
  width: fit-content;
  align-items: center;
  height: ${spacing(8)};
  gap: ${spacing(0.75)};
  padding: ${spacing(0.75)};
  border: 1px solid ${base_colorContentBorder};
  border-radius: ${spacing(2)};
  background-color: ${base_colorSurface};

  .SettingsSegmented-segment {
    display: inline-flex;
    align-items: center;
    height: 100%;
    padding: 0 ${spacing(3)};
    border: 1px solid transparent;
    border-radius: ${spacing(1.5)};
    background: none;
    cursor: pointer;
    white-space: nowrap;
    font-family: ${font_family_weight_regular};
    ${font_sm};
    color: ${text_colorTextSecondary};
    transition:
      background-color 0.15s ease,
      color 0.15s ease;
  }

  .SettingsSegmented-segment:hover:not(:disabled) {
    color: ${text_colorTextPrimary};
  }

  .SettingsSegmented-segment.selected {
    border-color: ${base_colorContentBorderSecondary};
    background-color: ${base_contentBackground};
    color: ${text_colorTextPrimary};
    font-family: ${font_family_weight_medium};
    box-shadow: 0 1px 2px rgba(20, 20, 43, 0.1);
  }

  .SettingsSegmented-segment:focus-visible {
    outline: 2px solid ${base_colorAction};
    outline-offset: 1px;
  }

  @media (prefers-reduced-motion: reduce) {
    .SettingsSegmented-segment {
      transition: none;
    }
  }
`
